(function ($) {
    $(document).ready(function () {
        let $testimonialsSlider = $('.testimonials-slider');

        if ($testimonialsSlider.length > 0) {
            $testimonialsSlider.each(function () {
                let $this = $(this);
                $this.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    // autoplay: true,
                    // autoplaySpeed: 4000,
                    arrows: false,
                    dots: true,
                    pauseOnHover: true,
                    variableWidth: true,
                    centerMode: true,
                    // centerPadding: '80px',
                    pauseOnFocus: true,
                    // swipe: false,
                    // swipeToSlide: false,
                    // mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                variableWidth: false,
                                centerMode: true,
                                centerPadding: '15px',
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            });
        }
    });
})(jQuery);
